import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI_POWERED_DOC_INLCM_3 = {
  title:
    "Design is autogenerated by the AI \nengine and available for the user to \ndownload.",
  subtitle: "Gen AI powered network design",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_3099"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_308"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_1.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_ai_powered_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "170px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_ai_powered_03_screen.png",
          imageStyle: { position: "absolute", bottom: "236px", right: "63px" },
        },
        {
          image: "ENG/INLCM/INLCM_ai_powered_0301_screen.png",
          imageStyle: { position: "absolute", bottom: "236px", right: "800px" },
        },
        {
          image: "ENG/INLCM/INLCM_ai_powered_03_network.png",
          imageStyle: { position: "absolute", bottom: "95px", right: "757px" },
        },
      ]}
      pageNumber={"ENG_309"}
    />
  ),
};
